import { s as script } from './Datepicker-r7KMGxsC.js';
import { u as use, a as registerComponent } from './plugins-1raZX6c5.js';
import './CompatFallthroughMixin-Ev2XGfi3.js';
import './config-nHWiBviw.js';
import './FormElementMixin-ILDlgM3i.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';
import 'vue';
import './DropdownItem-yQcaSZL4.js';
import './trapFocus-IMs77O3T.js';
import './Input-0ivJhXUC.js';
import './Icon-fJqkx1gN.js';
import './Field-CMd66v8h.js';
import './Select-DY-wGhZc.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};
use(Plugin);

export { script as BDatepicker, Plugin as default };
